import logo from '../../assets/logo.png'
import styled from 'styled-components'
import icoBack from '../../assets/icons/back.svg'
import {useContext, useState} from 'react'
import {OrderDataContext} from './Context/WaiterContext'
import ActionPopup from './Components/ActionPopup'

function Header({page, setPage, workendAction, setWorkendAction}) {
    const {order} = useContext(OrderDataContext)

    const renderBackArrow = () => {
        if (page === 'second') {
            return <Back onClick={() => setPage('first')}><img src={icoBack} alt='back'/></Back>
        } else if (page === 'third') {
            return <Back onClick={() => setPage('second')}><img src={icoBack} alt='back'/></Back>
        }
    };

    return (
        <Wrapper>
            <div>
                <Left>
                    {renderBackArrow()}
                </Left>
                <Center>
                    <Logo onClick={() => setPage(order.id || order.success ? 'menu' : 'time')}><img style={{ margin: "0 auto", width: "163px", maxWidth: "163px" }} src={logo} alt='boheme'/></Logo>
                </Center>
                <Right>
                    {workendAction && workendAction.id &&
                        <ActionPopup action={workendAction} setAction={setWorkendAction} includeButton={true}></ActionPopup>
                    }
                </Right>
            </div>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    background: #3F4041;
    color: #AE996F;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    padding-left: 15px;
    padding-right: 15px;
    z-index: 10;

    & > div {
        display: flex;
        width: 100%;
        max-width: 800px;
        align-items: center;
        justify-content: space-between;
        margin: 0 auto;
    }
`;

const Back = styled.div`
    cursor: pointer;
    img {
        height: 30px;
    }
`

const Logo = styled.div`
    cursor: pointer;
`

const Room = styled.div`
    text-align: center;
    font-size: 10px;
    float: right;
`

const Number = styled.div`
    font-size: 20px;
`
const Left = styled.div`
    flex: 1;
`

const Center = styled.div`
    flex: 1;
    text-align: center;
    padding-top: 15px;
    padding-bottom: 15px;
`

const Right = styled.div`
    flex: 1;
    text-align: right;
    justify-content: flex-end;
`

export default Header;
